module.exports = __webpack_public_path__ + "static/media/hurray.a4cb7e81.svg";